import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { animeArticles } from "@/mocks/animeData";
import AnimeCard from "@/components/base/AnimeCard";

export default function FeaturedReviews() {
  const { t } = useTranslation();
  const featured = animeArticles.filter((a) => a.featured).slice(0, 4);

  return (
    <section className="py-14 md:py-20">
      <div className="container-site">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading mb-3">
            {t("home.featuredTitle")}
          </h2>
          <p className="text-sm md:text-base text-foreground-600">
            {t("home.featuredSubtitle")}
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {featured.map((article) => (
            <AnimeCard key={article.id} article={article} />
          ))}
        </div>
        <div className="text-center mt-10">
          <Link
            to="/category/all"
            className="inline-flex items-center gap-2 px-6 py-3 rounded-full border border-background-300 text-foreground-700 text-sm font-medium hover:border-primary-400 hover:text-primary-500 transition-all duration-200 cursor-pointer"
          >
            {t("home.viewMore")}
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}